import React from 'react'
import {  AiOutlineJava } from "react-icons/ai";
// import { AiFillHtml5, AiFillGithub, AiFillDatabase, AiFillCloud, AiFillAndroid, AiOutlineConsoleSql, AiFillCode } from 'react-icons/ai';
// Import Simple Icons from react-icons
import { SiHtml5, SiCss3, SiJavascript, SiMysql, SiPython, SiPowershell, SiMicrosoftazure } from 'react-icons/si';

function Skills() {
   
    const skills = [
        { name: "HTML", icon: <SiHtml5 className="h-6 w-6 text-orange-600" /> },
        { name: "CSS", icon: <SiCss3 className="h-6 w-6 text-blue-500" /> },
        { name: "JavaScript", icon: <SiJavascript className="h-6 w-6 text-yellow-500" /> },
        { name: "MySQL", icon: <SiMysql className="h-6 w-6 text-blue-700" /> },
        { name: "Java", icon: <AiOutlineJava className="h-6 w-6 " /> },
        { name: "Python", icon: <SiPython className="h-6 w-6 text-blue-400" /> },
        { name: "PowerShell", icon: <SiPowershell className="h-6 w-6 text-indigo-600" /> },
        { name: "Azure Cloud Services", icon: <SiMicrosoftazure className="h-6 w-6 text-blue-700" /> }
      ];
   
    return (
        <section id='skills' className=" px-6 py-20 bg-[#8C3061] text-[#8C3061]  text-center">
            <h2 className="md:text-3xl text-xl font-bold text-white mb-8">Technical Skills</h2>
            <div className="grid grid-cols-2 gap-4">
                {skills.map((skill, index) => (
                <div key={index} className="flex items-center space-x-2 bg-white w-fit rounded-lg px-3 md:ml-56 ml-0 md:py-0 py-2">
                    {skill.icon}
                    <span className="text-sm ">{skill.name}</span>
                </div>
                ))}
            </div>
            </section>
    )
}

export default Skills
